export enum StatusLayout {
  Ativo = 'ATIVO',
  Inativo = 'INATIVO'
}

export enum EtapaConfiguracao {
  Configuracao_arquivo = 0,
  Configuracao_layout = 1,
}

export enum TipoDeArquivo {
  Txt = 'txt',
  Csv = 'csv',
  Xls = 'xls',
  Xlsx = 'xlsx',
}

export enum Separadores {
  Espaco = 'espaco',
  DoisPontos = ':',
  PontoEVirgula = ';',
  virgula = ',',
  // Fecha e abre aspas entre os campos: "a";"b". O 1º e o último campo
  // abrem/fecham as aspas com campos fixos.
  AspasEPontoEVirgula = '";"'
}

export enum Categorias {
  Empregado = 'empregado',
  Empregador = 'empregador',
  Fixo = 'fixo',
  Verba = 'verba',
  DataDeReferencia = 'data_de_referencia',
  Valor = 'valor',
  Sequencial = 'sequencial',
  TipoDaVerba = 'tipo_da_verba',
  UnidadeDaVerba = 'unidade_da_verba',
  NomeDoEvento = 'nome_do_evento',
  CampoCustomizavelPorEmpregado = 'campo_customizavel_por_empregado'
}

// formatação strftime
export enum CategoriaDataReferencia {
  AAAAMMDD = '%Y%m%d',
  AAAA_MM_DD_Barra = '%Y/%m/%d',
  AAAA_MM_DD_Hifen = '%Y-%m-%d',
  DD_MM_YYYY_Ponto = '%d.%m.%Y',
  DD_MM_YYYY_Barra = '%d/%m/%Y',
  DD_MM_YYYY_Hifen = '%d-%m-%Y',
  MMAAAA = '%m%Y',
  MMAAAA_Barra = '%m/%Y',
  MMAAAA_Hifen = '%m-%Y',
  AAAAMM = '%Y%m',
  DDMMAA = '%d%m%y'
}

export enum CategoriaEmpregadoEEmpregador {
  Nome = 'nome',
  Codigo = 'codigo',
  CPF = 'cpf',
  RG = 'rg',
  PIS = 'pis',
  CodigoLocalTrabalho = 'codigo_local_de_trabalho',
  NomeLocalTrabalho = 'local_de_trabalho.nome',
  Empregador_Nome = 'empregador.nome',
  Empregador_NomeComercial = 'empregador.nome_comercial',
  Empregador_CPF = 'empregador.cpf',
  Empregador_CNPJ = 'empregador.cnpj',
  Empregador_Codigo = 'empregador.codigo',
}

export enum TipoDelimitacao {
  Inicio = 'inicio',
  Fim = 'fim'
}
export enum CategoriaValor {
  Decimal = 'decimal',
  HorasEMinutos = 'hhmm',
  Inteiro = 'inteiro',
  Minutos = 'minutos'
}
export enum TipoDaVerba {
  Desconto = 'desconto',
  Bonus = 'bonus'
}
export enum UnidadeDaVerba {
  Dias = 'dias',
  Horas = 'horas'
}
export enum Alinhamento {
  Esquerda = '>',
  Direita = '<'
}

export enum QuebraDeLinha {
  LF = 'LF',
  CRLF = 'CRLF'
}
